<template>
    <div class="w-100 h-100">
        <div class="row h-100">
            <div class="col-lg-12 d-flex h-100">
                
                    <div class="np-canban-column-wrapper">
                        <div class="np-canban-column">
                            <div class="np-canban-column-header d-flex align-items-center">
                                <h6 class="title">{{ $t("UI.task.todayTask")}}<span class="tasks-count">{{ todayTasks.length }}</span></h6>
                            </div>
                            <div class="np-canban-column-body pt-2 pb-2">
                                <TaskCard
                                    v-for="elemTask in todayTasks"
                                    :key="elemTask.task.id"
                                    :task="getPreparedTask(elemTask.task)"
                                    :statusId="elemTask.statusId"
                                    :statuses="listStat"
                                    @showModTask="showModTask"
                                    @showArch="showArch"
                                    @showDel="showDel"
                                    @showMoveTo="showMoveTo"                                
                                />
                            </div>
                        </div>
                    </div>         
                    <div class="np-group np-group-column flex-grow-1">
                        <div class="np-group justify-content-start">
                            <div class="np-tabs np-mb-2">
                                <button :class="['np-tab', { active: currentMode === 'day' }]"@click="changeView('day')">
                                    <span>{{ $t("UI.project.day") }}</span>
                                </button>
                                <button :class="['np-tab', { active: currentMode === 'week' }]"@click="changeView('week')">
                                    <span>{{ $t("UI.project.week") }}</span>
                                </button>
                                <button :class="['np-tab', { active: currentMode === 'month-grid' }]"@click="changeView('month-grid')">
                                    <span>{{ $t("UI.project.month") }}</span>
                                </button>                                                        
                            </div>                
                        </div>        
                        <div class="np-panel h-100">
                            <div class="np-panel-body h-100" style="max-height: 100%;">
                               <!-- <Qalendar 
                                    ref="calendar"
                                    :key="calendarKey" 
                                    :config="this.calendarConfig" 
                                    :events="calendarEventsX"
                                    @event-was-clicked="calendarEventClick"
                                    :updated-mode="switchCalendarMode"
                                >
                                    <template #dayCell="{dayData}">
                                        <div class="cobalt-calendar__day-wrapper">
                                            <div class="cobalt-calendar__day"> {{ dayData.dateTimeString.substring(8, 10) }}</div>

                                            <div class="cobalt-calendar__events" v-if="dayData.events.length > 0">
                                                <div class="cobalt-calendar__event" 
                                                    v-for="event in this.calendarMonthDayTasks(dayData.events)" 
                                                    :key="event.id" 
                                                    @click="this.showModEvent(event.tasks)"
                                                    :style="{ 'background-color': event.color.bg, 'border-color': event.color.color }"
                                                >
                                                    <span :style="{ 'color': event.color.color }">{{ Object.values(event.tasks).flat().length }}</span>
                                                </div> 
                                            </div>
                                        </div>
                                    </template>                      
                                </Qalendar> 
                                -->

                                <ScheduleXCalendar ref="calendar" :key="calendarKey" :calendar-app="this.calendarConfigX">
                                    <template #monthGridEvent="{ calendarEvent, hasStartDate }">
                                        <div class="custom-day">
                                            <div class="day-events" :class="getPriorityClass(calendarEvent.priority)" @click="this.showModEvent(calendarEvent.tasks)">
                                                {{ calendarEvent.tasks.length }}
                                            </div>
                                        </div>
                                    </template>
                                </ScheduleXCalendar>                                
                            </div>
                        </div>
                    </div>
                
            </div>
        </div>            
    </div>

    <ShowEventTasks modalID="ShowEventTasks" modalSize="modal-md" modalPosition="center" ref="ShowEventTasks" class="cobalt-base-dialog">
        <template v-slot:header-left>         
            {{ $t("UI.calendar.eventTitle") }}
        </template>
        <template v-slot:body>
            <div class="modal-body ps-3 pe-3">
                <p class="pb-3">{{ $t("UI.calendar.eventTaskConfirmation") }}</p>
                
                <ul class="cobalt-tasks__list">
                    <li class="cobalt-task-light" v-for="eTask in this.eventTasks" :key="eTask.id" @click="this.showEventModTask(eTask.task.id, eTask.statusId)">
                        <TaskCardEvent
                            :task="getPreparedTask(eTask.task)"
                            :statusId="eTask.statusId"
                            @showModTask="showEventModTask"
                        />
                    </li>                    
                </ul>
            </div>
            <div class="modal-footer p-3">
                <button type="button" class="np-btn np-danger px-4"
                    data-bs-dismiss="modal">{{ $t("UI.close") }}
                </button>                        
            </div>             
        </template>
    </ShowEventTasks>      
</template>

<script>

import { localeDate, localeDateTime, eventDate, priorityValues } from '@/utils/format'
import TaskCard  from "@/components/TaskCard.vue" 
import TaskCardEvent  from "@/components/TaskCardEvent.vue" 
import ShowEventTasks from "@/components/modals/BsModal.vue"
import { Qalendar } from "qalendar";
import "qalendar/dist/style.css";

import { mapGetters, mapActions } from 'vuex';
import Config from '../../../config.js'

import { ScheduleXCalendar } from '@schedule-x/vue'
import {
  createCalendar,
  createViewDay,
  createViewMonthAgenda,
  createViewMonthGrid,
  createViewWeek,
} from '@schedule-x/calendar'
import '@schedule-x/theme-default/dist/index.css'
import { createCalendarControlsPlugin } from '@schedule-x/calendar-controls'

const calendarControls = createCalendarControlsPlugin()

export default {
    components: {
        TaskCard,
        TaskCardEvent,
        Qalendar,
        ScheduleXCalendar,
        ShowEventTasks,
    },
    props: {  
        tasks: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            Config,
            compInfo: null,
            eventTasks: [],
            priorityValues,
            currentMode: "month-grid",
            calendarKey: 0
        }
    },
    computed: {
        calendarConfig() {
            let config = {
                locale: this.$i18n.locale,
                defaultMode: 'month-grid',
                disableViews: ['day', 'week', 'month'],
                isEditable: true,
                style: {
                    colorSchemes: {}
                },
                eventDialog: {
                    isDisabled: true
                }
            }

            for (const priority of this.priorityValues) {
                config.style.colorSchemes["priority_" + priority.value] = {
                    color: priority.color,
                    backgroundColor: priority.bg
                }
            }
            return config
        },   
        calendarConfigX() {
            const calendar = createCalendar({
                    locale: this.$i18n.locale == 'ru' ? 'ru-RU' : 'en-US',
                    defaultView: this.currentMode,
                    disableViews: ['day', 'week', 'month-grid'],      
                    monthGridOptions: {
                        nEventsPerDay: 999,
                    },                              
                    views: [
                        createViewDay(),
                        createViewWeek(),
                        createViewMonthGrid(),
                        createViewMonthAgenda(),
                    ],
                    events: this.currentMode == 'month-grid' ? this.calendarEventsXMonth : this.calendarEventsX,
                }, 
                [calendarControls]
            )

            return calendar 
        },   
        calendarEvents: {
            get() {
                let minDate = null;
                let maxDate = null;

                // Шаг 1: Определение минимальной и максимальной даты среди всех задач
                for (const statusItem of Object.values(this.tasks)) {
                    statusItem.forEach(taskItem => {
                        if (taskItem.date_planned_start) {
                            const start = new Date(taskItem.date_planned_start * 1000);
                            start.setHours(0, 0, 0, 0); // Начало дня
                            minDate = minDate ? (start < minDate ? start : minDate) : start;
                        }
                        if (taskItem.date_planned_end) {
                            const end = new Date(taskItem.date_planned_end * 1000);
                            end.setHours(23, 59, 59, 59); // Начало дня
                            maxDate = maxDate ? (end > maxDate ? end : maxDate) : end;
                        }
                    });
                }

                // Если задачи нет или все даты пусты, возвращаем пустой массив
                if (!minDate || !maxDate) return [];

                // Шаг 2: Генерация всех дней между minDate и maxDate
                let days = [];
                for (let date = new Date(minDate); date <= maxDate; date.setDate(date.getDate() + 1)) {
                    days.push(new Date(date));
                }

                // Шаг 3: Создание событий для каждого дня и приоритета
                let events = [];
                for (const day of days) {
                    for (let priority = 0; priority < 5; priority++) {
                        // Создаем событие для каждого приоритета в каждом дне
                        events.push({
                            title: `Tasks with priority ${priority} on ${day.toISOString().split('T')[0]}`,
                            with: '',
                            time: { start: new Date(day.setHours(0, 0, 0, 0)), end: new Date(day.setHours(23, 59, 59, 999)) },
                            tasks: {}, // Массив задач с текущим приоритетом
                            color: this.priorityValues.find(option => option.value === priority),
                            priority: priority,
                            isEditable: false,
                            id: `day_${day.toISOString().split('T')[0]}_priority_${priority}`,
                            description: ''
                        });
                    }
                }

                // Шаг 4: Заполнение событий задачами по приоритетам
                for (const [statusId, statusItem] of Object.entries(this.tasks)) {
                    statusItem.forEach(taskItem => {
                        if (taskItem.date_planned_start && taskItem.date_planned_end) {
                            const taskStart = new Date(taskItem.date_planned_start * 1000);
                            taskStart.setHours(0, 0, 0, 0); // Начало дня
                            const taskEnd = new Date(taskItem.date_planned_end * 1000);
                            taskEnd.setHours(23, 59, 59, 999); // Конец дня
                            const priority = taskItem.priority;

                            // Добавляем задачу в события, которые попадают в диапазон её дат и совпадают по приоритету
                            for (const event of events) {
                                // Проверяем, что событие соответствует приоритету задачи и находится в её временном диапазоне
                                if (event.time.start >= taskStart && event.time.end <= taskEnd && event.priority == taskItem.priority) {
                                    if (!event.tasks[statusId])
                                        event.tasks[statusId] = []
                                    event.tasks[statusId].push(taskItem);
                                }
                            };
                        }
                    });
                }

                events.forEach(event => {
                    event.time.start = eventDate(event.time.start.getTime() / 1000)
                    event.time.end = eventDate(event.time.end.getTime() / 1000)
                })
                return events.filter(function( event ) { return Object.keys(event.tasks).length > 0 })

            }
        },
        calendarEvents2: {
            get() {
                const result = [];
                let elements = 0
                for (const [statusId, statusItem] of Object.entries(this.tasks)) {
                    statusItem.forEach(task => {
                        if (!task.date_planned_start || !task.date_planned_end) {
                            return
                        }
                        const start = new Date(task.date_planned_start * 1000)
                        const end = new Date(task.date_planned_end * 1000)

                        // Итерируем по каждому дню в интервале
                        for (
                            let date = start;
                            date <= end;
                            date.setDate(date.getDate() + 1)
                        ) {
                            elements++
                            // Определяем начало и конец для текущего дня
                            let currentDayStart = date
                            currentDayStart.setHours(0, 0, 0) // Начало дня (полночь)
                            const cds = currentDayStart.getTime()

                            let currentDayEnd = date
                            currentDayEnd.setHours(23, 59, 59) // Конец дня
                            const cde = currentDayEnd.getTime()

                            // Вычисляем реальный start и end для текущего дня
                            const dayStart = Math.max(task.date_planned_start, cds / 1000)
                            const dayEnd = Math.min(task.date_planned_end, cde / 1000)

                            result.push({
                                title: task.title,
                                with: '',
                                time: { start: eventDate(dayStart), end: eventDate(dayEnd) },
                                task: task,
                                backgroundColor: this.priorityValues.find(option => option.value === task.priority).bg,
                                priority: task.priority,
                                statusId: statusId,
                                isEditable: false,
                                id: 'day_' + task.id + '_priority_' + task.priority + dayStart + dayEnd,
                                description: ''
                            })
                        }
                    })
                }

                console.log("Calendar events: " + elements)

                return result;
            }
        },  
        calendarEventsX: {
            get() {
                let result = [];
                let elements = 0
                for (const [statusId, statusItem] of Object.entries(this.tasks)) {
                    statusItem.forEach(task => {
                        if (!task.date_planned_start || !task.date_planned_end) {
                            return
                        }
                        const start = task.date_planned_start
                        const end = task.date_planned_end

                            result.push({
                                title: task.title,
                                with: '',
                                start: eventDate(start), 
                                end: eventDate(end),
                                //time: { start: eventDate(start), end: eventDate(end) },
                                task: task,
                                priority: task.priority,
                                colorScheme: "priority_" + task.priority,
                                statusId: statusId,
                                isEditable: false,
                                id: task.id,
                            })
                        }
                    )
                }

                return result
            }
        },  
        calendarEventsXMonth: {
            get() {
                let result = [] 

                for (const [statusId, statusItem] of Object.entries(this.tasks)) {
                    statusItem.forEach(task => {
                        if (!task.date_planned_start || !task.date_planned_end) {
                            return
                        }
                        const start = task.date_planned_start
                        const end = task.date_planned_end

                            result.push({
                                title: task.title,
                                with: '',
                                start: start, 
                                end: end,
                                task: task,
                                priority: task.priority,
                                colorScheme: "priority_" + task.priority,
                                statusId: statusId,
                                isEditable: false,
                                id: task.id,
                            })
                        }
                    )
                }

                result = this.splitMultiDayEvents(result)

                return result
            }
        },                         
        todayTasks: {
            get() {
                let taskArray = []
                let today = new Date().getTime() / 1000
                
                for (var key in this.tasks) {
                    this.tasks[key].forEach(task => {

                        if (!!task.date_actual_end) return

                        if ( !task.date_planned_start ) {
                            if (task.date_planned_end) {
                                if (today < task.date_planned_end ) {
                                    taskArray.push({'task': task, 'statusId': key })
                                }
                            } else {
                                taskArray.push({'task': task, 'statusId': key })
                            }
                        } 
                        else 
                            if (!task.date_planned_end) {
                                if (task.date_planned_start < today) {
                                    taskArray.push({'task': task, 'statusId': key })
                                }
                            } else {
                                if (task.date_planned_start < today && task.date_planned_end > today) {
                                    taskArray.push({'task': task, 'statusId': key })
                                }
                            }

                    })
                }
                return taskArray
            }
        }              
    },
    watch: {
        '$i18n.locale'() {
            this.calendarKey += 1;
        }
    },       
    methods: {
        ...mapActions('company', ['list', 'addCompany', 'delete']),
        ...mapGetters('company', ['getList']),     
        localeDate,
        localeDateTime, 
        eventDate,

        getPreparedTask(task) {
            const priorityObj = this.priorityValues.find(option => option.value === task.priority);
            return {
                ...task,
                priorityObj
            };
        },
        getPriorityClass(value) {
            const priorityObj = this.priorityValues.find(option => option.value === value)
            return priorityObj ? priorityObj.class : 'np-default'
        },
        calendarMonthDayTasks(dayEvents) {
            let events = []

            if (dayEvents.length == 0) return events

            for (let priority = 0; priority < 5; priority++) {
                events.push({
                    title: `Tasks with priority ${priority} on ${dayEvents[0].time.start}`,
                    with: '',
                    time: { start: '', end: '' },
                    tasks: [], 
                    color: this.priorityValues.find(option => option.value === priority),
                    priority: priority,
                    isEditable: false,
                    id: `day_${dayEvents[0].time.start}_priority_${priority}`,
                    description: ''
                })
            }

            for (const event of dayEvents) {
                events[event.priority].time.start = event.time.start
                events[event.priority].time.end = event.time.end
                events[event.priority].tasks.push(event)
            }

            const res = events.filter(function( event ) { return Object.keys(event.tasks).length > 0 })            
            return res
        },
        splitMultiDayEvents(events) {
            const daysMap = {};

            events.forEach(event => {
                // Проверяем и исправляем ID события
                const eventId = this.validateEventId(event.id);
                
                let currentDate = new Date(event.start * 1000);
                currentDate.setHours(0, 0, 0, 0); // Начало дня
                const endDate = new Date(event.end * 1000);
                endDate.setHours(0, 0, 0, 0);

                while (currentDate <= endDate) {
                const dayKey = currentDate.toISOString().split('T')[0];
                const priority = event.priority;
                
                if (!daysMap[dayKey]) daysMap[dayKey] = {};
                if (!daysMap[dayKey][priority]) {
                    daysMap[dayKey][priority] = {
                    id: `${dayKey}-${priority}`, // Уникальный ID для группы
                    priority: priority,
                    statusId: event.statusId,
                    colorScheme: "priority_" + priority,
                    tasks: [],
                    start: this.eventDate(currentDate.getTime() / 1000),
                    end: this.eventDate(
                        new Date(
                        currentDate.getFullYear(),
                        currentDate.getMonth(),
                        currentDate.getDate(),
                        23, 59, 59
                        ).getTime() / 1000
                    )
                    };
                }

                daysMap[dayKey][priority].tasks.push({
                    id: eventId, // Используем валидированный ID
                    title: event.title,
                    originalEvent: event
                });

                currentDate.setDate(currentDate.getDate() + 1);
                currentDate.setHours(0, 0, 0, 0);
            }
            });

            // Преобразуем в плоский массив
            return Object.values(daysMap).flatMap(day => Object.values(day));
        },

        // Валидация ID (добавьте этот метод в ваш компонент)
        validateEventId(id) {
        if (!id) return Math.random().toString(36).substring(2, 9); // Генерация случайного ID если нет
        return String(id).replace(/[^a-zA-Z0-9-_]/g, ''); // Удаляем недопустимые символы
        },        
        calendarEventClick(event) {
            this.$emit('showModTask', event.clickedEvent.id, event.clickedEvent.statusId)
        },        
        switchCalendarMode(event) {
            console.log(event)
        },
        changeView(view) {
            this.currentMode = view
            this.calendarKey++
            calendarControls.setView(view);
        },        
        getPriority(task) {
            const priorityObj = this.priorityValues.find(option => option.value === task.priority)
            return priorityObj
        }, 
        showModEvent(events) {
            this.eventTasks = []

            if ( events.length > 1 ) {
                events.forEach(event => {
                    this.eventTasks.push({
                        statusId: event.originalEvent.statusId,
                        task: event.originalEvent.task
                    })    
                })
                this.$refs.ShowEventTasks.shows()
            } else {
                this.$emit('showModTask', events[0].originalEvent.task.id, events[0].originalEvent.statusId)
            }
        },   
        showEventModTask(taskId, statusId) {
            this.$refs.ShowEventTasks.hide()
            this.$emit('showModTask', taskId, statusId)
        }, 
        refresh() {
            this.$emit('refresh')
        }          
    }

}
</script>

<style>
    .sx__calendar {
        border: none;
    }
    .sx-vue-calendar-wrapper {
        height: 100%;
    }
    .sx__today-button, .sx__view-selection, .sx__date-picker-wrapper {
        display: none;
    }
    .sx__calendar-header-content {
        flex-direction: row-reverse;
    }    
    .sx__month-grid-day {
        padding: 15px;
    }
    .sx__month-grid-day__events {
        display: flex;
        gap: 7px;
        justify-content: flex-start;
        flex-wrap:wrap;
    }
    .sx__month-grid-cell {
        height: auto;
        width: 25% !important;
    }
    .sx__month-grid-day__events .sx-event {

    }
    .sx__month-grid-week:first-child {
        border-top: none;
    }
    .day-events {
        padding: 5px 10px;
        border-radius: 7px;
        line-height: 12px;
        width: 26px;
    }
    .sx__month-grid-day__header-date {
        width: 42px;
        height: 32px;
        margin-bottom: 10px;
    }
    .sx__month-grid-day__header-date.sx__is-today {
        padding: 5px 5px;
        background-color: #405B7C;
        border-radius: 10px;
    }
    .sx__month-grid-blocker {
        pointer-events: none;
        display: none;
    }
    .sx__month-grid-day__header-day-name {
        font-size: 14px;
        text-transform: uppercase;
        font-weight: 500;
        color: #405B7C;
    }   
    .sx__month-grid-event {
        width: 26px;
        min-width: 26px;
        height: 22px;
        font-size: 10px;
    }     
</style>